import createReducer from 'utils/redux/createReducer'

const initialState = {
  leftNav: true,
  rightNav: true,
}

export default createReducer(initialState, {
  TOOGLE_LEFT_NAV: (currentState) => ({...currentState, leftNav: !currentState.leftNav}),
  CLOSE_LEFT_NAV: (currentState) => ({...currentState, leftNav: false}),
  TOOGLE_FILTERS_PANEL: (currentState) => ({...currentState, rightNav: !currentState.rightNav})
})



// WEBPACK FOOTER //
// ./src/reducers/actionBarReducers.js